// utils/timeline.ts

/**
 * Format date string for timeline display
 */
export function formatTimelineDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  } catch {
    return dateString;
  }
}

/**
 * Calculate timeline event position with collision avoidance
 * CRITICAL: Handles same-date events to prevent division by zero
 */
export function calculateTimelinePosition(
  eventDate: Date,
  firstDate: Date,
  lastDate: Date,
  eventIndex: number,
  totalEvents: number,
  containerWidth = 800,
  minEventWidth = 140
): number {
  const totalTimespan = lastDate.getTime() - firstDate.getTime();

  // CRITICAL: Handle same-date events to prevent division by zero
  if (totalTimespan === 0) {
    // Evenly distribute events if all have same date
    return totalEvents === 1 ? 50 : (eventIndex / (totalEvents - 1)) * 100;
  }

  const rawPosition =
    ((eventDate.getTime() - firstDate.getTime()) / totalTimespan) * 100;

  // Calculate bounds to prevent overlap
  const minSpacingPercent = (minEventWidth / containerWidth) * 100;
  const minPosition = eventIndex * minSpacingPercent;
  const maxPosition = 100 - (totalEvents - eventIndex) * minSpacingPercent;

  return Math.max(Math.min(rawPosition, maxPosition), minPosition);
}
